import dayjs from 'dayjs';
import { getApi, postApi } from '../../utils/api';

export interface IUserAbsences {
  userId: number;
  daysOfAbsence: number;
}

export interface IUserAbsencesPost {
  date: string;
  daysOfAbsence: number;
}

export const getUserAbsences = (date: Date) =>
  getApi<IUserAbsences>(
    `dailycapacity/absence/?date=${dayjs(date).format('YYYY-MM-DD')}`
  );

export const postUserAbsences = (date: Date, daysOfAbsence: number) =>
  postApi<IUserAbsences, IUserAbsencesPost>('dailycapacity/absence', {
    date: dayjs(date).format('YYYY-MM-DD'),
    daysOfAbsence,
  });
